import barba from '@barba/core';
// import gsap from "gsap";
// import ScrollTrigger from "gsap/ScrollTrigger";

//gsap.registerPlugin(ScrollTrigger);

export default class {
	constructor() {
		barba.hooks.beforeOnce((data) => {
			this.init();
		});
		barba.hooks.after((data) => {
			this.init();
		});
	}
	init() {
		const strs = document.querySelectorAll("[data-str-anim]");
		if (strs.length > 0) {
			strs.forEach((el) => {
				let pr_str = el.textContent.split("");
				let str = "";
				pr_str.map((s, index) => {
					str += `<span class='str--split' style="animation-delay: ${index * 0.05}s">${s}</span>`;
				});
				el.innerHTML = str; // Replace the content with split spans
			});
		}

		// const strsEN = document.querySelectorAll("[data-str-ornament]");
		// if (strsEN.length > 0) {
		// 	strsEN.forEach((el) => {
		// 		let pr_str = el.textContent.split("");
		// 		let str = "";
		// 		pr_str.map((s, index) => {
		// 			str += `<span class='str--split' style="animation-delay: ${index * 0.0145}s">${s}</span>`;
		// 		});
		// 		el.innerHTML = str; // Replace the content with split spans
		// 	});
		// }
	}
}
